export const isDirectAssetUrl = (value: string): boolean =>
  value.startsWith('/') || value.startsWith('http://') || value.startsWith('https://');
